import { useNavigate } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

export const C = { cream: "#FAF6F0", coral: "#E06D53", coralDark: "#C85B43", teal: "#36858B", tealDark: "#2B6B70", gold: "#D9A036", ink: "#2D2824", muted: "#6E665E" };

export const StartFreeButton = ({ testId, className = "" }) => {
  const navigate = useNavigate();
  return (
  <button
    data-testid={testId}
    onClick={() => navigate("/account")}
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#E06D53] px-6 py-4 text-base font-semibold text-white shadow-md transition-[transform,background-color,box-shadow] hover:-translate-y-0.5 hover:bg-[#C85B43] hover:shadow-lg active:scale-95 ${className}`}
  >
    Start Your Childhood Journey Free <ArrowRight size={18} weight="bold" />
  </button>
  );
};

export const Eyebrow = ({ children, color = "#C85B43" }) => (
  <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em]" style={{ color }}>
    <Sparkle size={12} weight="fill" /> {children}
  </p>
);
